










































































































import * as _ from "lodash"
import {Vue, Component, Lifecycle, Prop, Mixin, Watch, p} from 'av-ts'

import {Card} from '../deckard/models/Card'
import {Set} from '../deckard/models/Set'
import {Deck} from '../deckard/models/Deck'
import {SearchQuery} from '../deckard/models/search/SearchQuery'

import {CardDatabase} from '../deckard/storage/CardDatabase'

import CardGrid from './CardGrid.vue'
import ImageCheckBox from './ImageCheckBox.vue'
import NumericCriteriaInput from './NumericCriteriaInput.vue'
import LoadingSpinner from './LoadingSpinner.vue'

import vSelect from 'vue-select'

@Component({
    components: {'CardGrid' : CardGrid, 'vSelect': vSelect, 'LoadingSpinner': LoadingSpinner,
                 'ImageCheckBox': ImageCheckBox, 'NumericCriteriaInput': NumericCriteriaInput }
})
export default class Search extends Vue
{
    currentlySearching: boolean = false;

    showAdvanced: boolean = true;

    searchQuery: string = "";
    foundCards: Card[] = [];
    searchIconPath = require('!svg-inline-loader!../assets/icons/ui/search.svg');
    moreIconPath = require('!svg-inline-loader!../assets/icons/ui/more.svg');


    cardTypes: string[] = [];
    cardSubTypes: string[] = [];
    allFormats: string[] = ["Standard", "Modern", "Commander", "Legacy"];
    allSets: Set[] = [];

    currentQuery: SearchQuery = new SearchQuery();
    hasLoaded: boolean = false;
    noCardsFound: boolean = false;

    get deck()
    {
        return this.$store.state.deck.currentDeck;
    }

    get queryDetails()
    {
        let ret: string[] = [];
        let s: SearchQuery = this.currentQuery;

        if (s.name) { ret.push(`Name: ${s.name}`); }
        if (s.rules) { ret.push(`Rules: ${s.rules}`); }
        
        if (s.types.length > 0) { ret.push(s.types.join(', ')); }
        if (s.subtypes.length > 0) { ret.push(s.subtypes.join(', ')); }

        let setNames = _.map(s.sets, function(set) { return set.name; });
        if (s.sets.length > 0) { ret.push(setNames.join(', ')); }

        if (s.cmc.comparison != "N/A") { ret.push(`CMC ${s.cmc.comparison} ${s.cmc.value}`); }
        if (s.power.comparison != "N/A") { ret.push(`Power ${s.power.comparison} ${s.power.value}`); }
        if (s.toughness.comparison != "N/A") { ret.push(`Toughness ${s.toughness.comparison} ${s.toughness.value}`); }

        if (s.selectedColors.length > 0) { ret.push(s.selectedColors.join(', ')); }

        if (s.excludeUnselectedColors) { ret.push('Exclude Unselected Colors'); }
        if (s.onlyMulticolor) { ret.push('Only multicolor'); }

        return ret.join(', ');
    }

    performSearch()
    {
        let thisVue:Search = this;

        thisVue.currentlySearching = true;
        thisVue.noCardsFound = false;
        thisVue.foundCards = [];

        if (this.showAdvanced)
        {
            CardDatabase.instance.advancedSearchCards(this.currentQuery)
                .then(function(cards)
                {
                    thisVue.foundCards = cards;
                    thisVue.currentlySearching = false;

                    if (cards.length == 0)
                    {
                        thisVue.noCardsFound = true;
                    }
                });
        }
        else
        {
            CardDatabase.instance.searchCards(this.searchQuery)
                .then(function(cards)
                {
                    thisVue.foundCards = cards;
                    thisVue.currentlySearching = false;

                    if (cards.length == 0)
                    {
                        thisVue.noCardsFound = true;
                    }
                });
        }
    }

    // lifecycle hook
    @Lifecycle mounted()
    {
        if (localStorage["search"] != undefined)
        {
            var load = SearchQuery.revive(JSON.parse(localStorage["search"]));

            this.currentQuery = load;
        }

        this.hasLoaded = true;

        let thisVue:Search = this;

        CardDatabase.instance.getAllSubtypes()
            .then(function(types)
            {
                thisVue.cardSubTypes = types;
            });

        CardDatabase.instance.getAllTypes()
            .then(function(types)
            {
                thisVue.cardTypes = types;
            });

        CardDatabase.instance.getAllSets()
            .then(function(sets: Set[])
            {
                thisVue.allSets = sets;
            });
    }

    @Lifecycle updated()
    {
        if (this.hasLoaded)
        {
            localStorage["search"] = JSON.stringify(this.currentQuery);
        }
    }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Search.vue